import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../../components/ui/button';

export const PrepPaymentCancel = () => (
  <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center px-4">
    <div className="bg-white rounded-2xl shadow-xl p-10 max-w-md w-full text-center">
      <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <XCircle className="text-red-500" size={44} />
      </div>
      <h1 className="text-3xl font-bold text-gray-900 mb-3">Payment Cancelled</h1>
      <p className="text-gray-600 mb-8">
        Your payment was not completed. No charges were made. You can try again anytime.
      </p>
      <Link to="/prep/programs">
        <Button className="w-full bg-blue-600 hover:bg-blue-700 text-white text-lg py-6" data-testid="try-again-btn">
          Back to Programs
        </Button>
      </Link>
    </div>
  </div>
);
